import { useMemo } from 'react';

export function useDefault<T>(value: T, defaultValue: T): T {
  return useMemo(() => value || defaultValue, [value]);
}

export default useDefault;
